import svgConnect from "../../../../assets/imgs/socials/connects/telegram.svg";
import svgNaoConectado from "../../../../assets/imgs/socials/notConnects/telegram.svg";

import MyImage from "../../../myImage"

const MyIconTelegram = ({sx, connect}) =><MyImage src={connect ? svgConnect : svgNaoConectado} alt={'telegram icon'} sx={sx} />

export default MyIconTelegram;
